// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"24":"companies","454":"applications","501":"administration","778":"people","809":"users","884":"admin"}[chunkId] || chunkId) + "." + {"24":"7dfcfd22","454":"51ebaf5c","495":"b71d5020","501":"ce2d3821","778":"3431735b","809":"8dd254bb","884":"99525337"}[chunkId] + ".css";
};